import { styled } from '@mui/material/styles';
import Modal from "../../Modals";

const AuthLayout = ({ children }) => {
  return (
    <RootWrapper
    >
      {children}
      <Modal />
    </RootWrapper>
  )
}

export default AuthLayout;

const RootWrapper = styled('div')(({ theme, overflowY, pathname }) => ({
  width: '100%',
  height: '100vh',
  position: 'relative',
  backgroundColor: '#fff',
  backgroundSize: 'cover'
}))